// Fire-and-forget ping to the API web service so it spins up before the user
// clicks through to the app. Render's free plan sleeps after 15 min idle and
// takes 30-60s to wake; this hides that latency behind the time the visitor
// spends reading the landing page.
//
// Credential-less so the browser skips the CORS preflight; `keepalive` lets
// the request survive an immediate navigation away from the page.

export function wakeUp(): void {
  const base = (import.meta.env.VITE_API_BASE ?? "").trim().replace(/\/$/, "");
  const url = `${base}/api/health`;
  try {
    void fetch(url, {
      credentials: "omit",
      cache: "no-store",
      keepalive: true,
    }).catch(() => {});
  } catch {
    // Some browsers throw synchronously on bad URLs — never let this break
    // the page render.
  }
}
